import React, { useEffect, useRef, useState } from "react";
import Card from "components/common/Card";
import otpImg from "assets/images/otp.svg";
import Button from "components/semantic/Button";
import { useAppDispatch, useAppSelector, useUserDetails } from "utils/hooks";
import { createUserThunk, verifyOtpThunk } from "store/thunk/main.thunk";
import { useNavigate } from "react-router-dom";

const Otp = () => {
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
  const [timer, setTimer] = useState(30);

  const currentUserDetails = useUserDetails();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isLoading = useAppSelector((state) => state.rootReducer.mainSlice.otpLoading);

  const handleChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasteData = e.clipboardData.getData("Text").trim();
    if (/^\d{6}$/.test(pasteData)) {
      const newOtp = pasteData.split("");
      setOtp(newOtp);
      newOtp.forEach((digit, i) => {
        if (inputRefs.current[i]) {
          inputRefs.current[i]!.value = digit;
        }
      });
      inputRefs.current[5]?.focus();
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (otp.every((digit) => digit !== "")) {
      handleSubmit();
    }
  }, [otp]);

  const resendHandler = async () => {
    const payload = {
      polHolderEmail: currentUserDetails.email,
      polHolderName: currentUserDetails.name,
      polHolderPhone: currentUserDetails.phone
    };
    dispatch(createUserThunk(payload));
    setTimer(30);
    setOtp(new Array(6).fill(""));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timer]);

  const handleSubmit = () => {
    const payload = {
      polHolderEmail: currentUserDetails.email,
      polHolderName: currentUserDetails.name,
      polHolderPhone: currentUserDetails.phone,
      otp: otp.join("")
    };
    dispatch(verifyOtpThunk(payload))
      .unwrap()
      .then((data) => {
        if (data?.success) {
          navigate("/kyp/policies");
        }
      });
  };

  return (
    <div>
      <p className="text-2xl font-extrabold mb-6 ">OTP Verification</p>
      <Card className="  w-full">
        <div className="flex flex-col-reverse lg:flex-row  justify-between md:p-10">
          <div className="p-1 lg:p-5 flex flex-col gap-3">
            <p className="font-extrabold text-xl text-center lg:text-start">Enter Verification Code</p>
            <p className="font-semibold text-sm lg:text-xl text-center lg:text-start">
              Please enter the 6-digit code sent to <span className="font-extrabold whitespace-nowrap">{currentUserDetails ? "+91-" + currentUserDetails.phone : "-"}</span>
            </p>

            <div className="flex gap-2 justify-center lg:justify-start flex-wrap gap-x-2 md:gap-x-5 my-4">
              {otp.map((digit, index) => (
                <input key={index} type="text" inputMode="numeric" placeholder="-" maxLength={1} value={digit} onChange={(e) => handleChange(e.target.value, index)} onKeyDown={(e) => handleKeyDown(e, index)} onPaste={handlePaste} ref={(el) => (inputRefs.current[index] = el)} className="w-11 lg:w-16 h-11 lg:h-16 border-[1px] border-[#CCCCCC] rounded-md text-center text-2xl lg:text-3xl font-extrabold focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-center leading-none pt-[2px]" />
              ))}
            </div>
            <p className="font-bold text-sm lg:text-base text-center lg:text-start">
              Didn't receive code?{" "}
              {timer === 0 ? (
                <span className="text-polifyx-theme cursor-pointer" onClick={resendHandler}>
                  Resend Code
                </span>
              ) : (
                <span className="text-[#FF8B84]">{` Resend in ${timer} seconds`}</span>
              )}
            </p>
          </div>
          <div className="flex items-center justify-center">
            <img src={otpImg} className="p-7 lg:p-0" />
          </div>
        </div>
        <hr className="my-2" />

        <div className="flex justify-center py-5">
          <Button type="submit" title="NEXT" onClick={handleSubmit} isLoading={isLoading} />
        </div>
      </Card>
    </div>
  );
};

export default Otp;
